import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from 'react';
import SidebarPageLayout from '../components/layout/SidebarPageLayout';

function TermsConditions() {

  useEffect(() => {
    document.title = 'Vivosol Plant Performance Insights Hub - Terms & Conditions';
  }, []);

  return (
    <SidebarPageLayout>
      <div className="content p-5" style={{ maxWidth: '52rem' }}>
        <h1 className="mb-3">Terms &amp; Conditions</h1>
        <p className="text-muted mb-5">Last updated: August 11, 2026</p>

        <p className="mb-4">
          These Terms &amp; Conditions (&quot;Terms&quot;) govern access to and use of the VivoSol Plant
          Performance Insights Hub and related services (the &quot;Service&quot;) provided by VivoSol
          (&quot;VivoSol,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;). By accessing or using the Service, you agree to
          these Terms on behalf of yourself and the organization you represent.
        </p>

        <h2 className="h4 mt-4">1. Eligibility and accounts</h2>
        <p>
          The Service is intended for authorized business users. You must be at least 18 years
          old and have authority to bind your organization to these Terms. You are responsible
          for maintaining the confidentiality of your credentials, restricting access to
          authorized personnel, and for activity that occurs under your account. Notify us
          promptly of any unauthorized use or security incident involving your account.
        </p>

        <h2 className="h4 mt-4">2. License and acceptable use</h2>
        <p>
          Subject to these Terms and any applicable customer agreement, we grant you a limited,
          non-exclusive, non-transferable, revocable right to access and use the Service for
          your organization&apos;s internal business purposes related to plant monitoring,
          diagnostics, insights, and reporting.
        </p>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service in violation of law or third-party rights;</li>
          <li>Share access with unauthorized persons or resell the Service without our written consent;</li>
          <li>Reverse engineer, decompile, or attempt to extract source code except where prohibited by law;</li>
          <li>Interfere with or disrupt the Service, security, or related infrastructure;</li>
          <li>Probe, scan, or test vulnerabilities without prior written authorization;</li>
          <li>Upload malware or content that is unlawful, harmful, or infringing; or</li>
          <li>Use automated means to scrape or overload the Service except through documented APIs we provide.</li>
        </ul>

        <h2 className="h4 mt-4">3. Customer data</h2>
        <p>
          You (or your organization) retain ownership of data, configurations, telemetry, and
          content submitted to or generated for you in the Service (&quot;Customer Data&quot;). You grant
          VivoSol a limited license to host, process, transmit, and display Customer Data solely
          to provide and improve the Service, prevent abuse, and meet legal obligations. You
          represent that you have all rights and consents needed to provide Customer Data to us
          and that doing so does not violate applicable law or third-party agreements.
        </p>

        <h2 className="h4 mt-4">4. Intellectual property</h2>
        <p>
          The Service, including software, models, documentation, designs, trademarks, and
          related materials, is owned by VivoSol or its licensors and is protected by
          intellectual property laws. Except for the limited license above, no rights are
          granted. Feedback you provide may be used by us without obligation to you.
        </p>

        <h2 className="h4 mt-4">5. Third-party services</h2>
        <p>
          The Service may integrate with third-party products (for example identity providers,
          cloud hosting, or data platforms). Your use of those products is subject to their
          terms. We are not responsible for third-party services we do not control.
        </p>

        <h2 className="h4 mt-4">6. Availability and changes</h2>
        <p>
          We aim to keep the Service available and reliable, but do not guarantee uninterrupted
          or error-free operation. Features may change, be updated, or be discontinued. We may
          suspend access for maintenance, security risk, non-payment (where applicable), or
          material breach of these Terms.
        </p>

        <h2 className="h4 mt-4">7. Confidentiality</h2>
        <p>
          Each party may receive confidential information from the other. The receiving party
          will use reasonable care to protect that information and use it only as needed to
          perform under these Terms, except where the information is public, independently
          developed, or required to be disclosed by law (with notice where legally permitted).
        </p>

        <h2 className="h4 mt-4">8. Disclaimers</h2>
        <p>
          THE SERVICE AND ALL RELATED CONTENT ARE PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE.&quot; TO THE
          MAXIMUM EXTENT PERMITTED BY LAW, VIVOSOL DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS,
          IMPLIED, OR STATUTORY, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
          TITLE, AND NON-INFRINGEMENT. Operational insights, forecasts, alarms, and analytics
          are decision-support tools only; you remain responsible for plant operations, safety,
          and compliance decisions.
        </p>

        <h2 className="h4 mt-4">9. Limitation of liability</h2>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, VIVOSOL AND ITS AFFILIATES, OFFICERS,
          EMPLOYEES, AND SUPPLIERS WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL,
          CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR FOR LOST PROFITS, REVENUE, DATA, OR
          BUSINESS INTERRUPTION, EVEN IF ADVISED OF THE POSSIBILITY. OUR TOTAL LIABILITY
          ARISING OUT OF OR RELATED TO THE SERVICE WILL NOT EXCEED THE AMOUNTS PAID BY YOUR
          ORGANIZATION TO VIVOSOL FOR THE SERVICE IN THE TWELVE (12) MONTHS BEFORE THE CLAIM,
          OR ONE HUNDRED U.S. DOLLARS (US $100) IF NO FEES WERE PAID. Some jurisdictions do not
          allow certain limitations; in those cases our liability is limited to the fullest
          extent permitted.
        </p>

        <h2 className="h4 mt-4">10. Indemnification</h2>
        <p>
          You will defend and indemnify VivoSol against claims, damages, and expenses arising
          from your (or your users&apos;) misuse of the Service, violation of these Terms, or
          Customer Data that infringes or misappropriates third-party rights or violates law.
        </p>

        <h2 className="h4 mt-4">11. Termination</h2>
        <p>
          You may stop using the Service at any time. We may suspend or terminate access if you
          breach these Terms or if required for security or legal reasons. Upon termination,
          your license ends. Provisions that by nature should survive (including ownership,
          confidentiality, disclaimers, limitations of liability, and indemnification) will
          survive. Customer Data handling after termination follows the applicable customer
          agreement and our Privacy Policy.
        </p>

        <h2 className="h4 mt-4">12. Governing law</h2>
        <p>
          These Terms are governed by the laws of the State of California, excluding conflict
          of law rules, unless a signed customer agreement specifies otherwise. Courts located
          in California will have exclusive jurisdiction over disputes arising from these Terms,
          except where mandatory law provides otherwise.
        </p>

        <h2 className="h4 mt-4">13. Changes to these Terms</h2>
        <p>
          We may update these Terms from time to time. We will post the revised version on this
          page and update the &quot;Last updated&quot; date. Continued use of the Service after changes
          become effective constitutes acceptance, except where applicable law or a signed
          agreement requires additional notice or consent.
        </p>

        <h2 className="h4 mt-4">14. Contact us</h2>
        <p>
          For questions about these Terms, contact{' '}
          <a href="mailto:jngai@ennovara.com">Judy Ngai, jngai@ennovara.com</a>.
        </p>
      </div>
    </SidebarPageLayout>
  );
}

export default TermsConditions;
